import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { setTokenCookies } from 'tools/cookieTools';

import {
  googleLoginEndpoint,
  googleRegisterEndpoint,
  loginEndpoint,
} from 'services/user-management/userManagementApiService';

import { ProfileType, UserProfileType, UserType } from 'types/core/userTypes';
import { ContactDetailResType } from 'types/promoters/promoterTypes';
import { ACTIVATION_STATUS } from 'types/user-management/auth';

export const SLICE_NAME = 'authSlice';

export type AuthState = {
  accessToken?: UserType['accessToken'] | null;
  tokenType?: UserType['tokenType'] | null;
  expiresIn?: UserType['expiresIn'] | null;
  refreshToken?: UserType['refreshToken'] | null;
  refreshTokenExpiresIn?: UserType['refreshTokenExpiresIn'] | null;
  userProfile?: UserProfileType | null;
  profile?: ProfileType | null;
  service?: ContactDetailResType | null;
  isLoggedIn?: boolean;
};

const initialState: AuthState = {
  accessToken: null,
  tokenType: null,
  expiresIn: null,
  refreshToken: null,
  refreshTokenExpiresIn: null,
  userProfile: null,
  profile: null,
};

export const authSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setAuthState: (state, action: PayloadAction<AuthState>) => {
      return { ...state, ...action.payload };
    },
    setProfile: (state, action: PayloadAction<ProfileType | null>) => {
      state.profile = action.payload;
    },
    setService: (state, action: PayloadAction<ContactDetailResType | null>) => {
      state.service = action.payload;
    },
    readProfileMessage: (state) => {
      if (state.profile?.unreadMessages && state.profile.unreadMessages > 0) {
        state.profile.unreadMessages -= 1;
      }
    },
    receiveMessage: (state, action: PayloadAction<number>) => {
      if (state.profile) {
        state.profile.unreadMessages = action.payload;
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(loginEndpoint.matchFulfilled, (state, action) => {
      if (action.payload.activationStatus === ACTIVATION_STATUS.CONFIRMED) {
        state.isLoggedIn = true;
        setTokenCookies(action.payload.accessToken, action.payload.refreshToken);
      }
    });
    builder.addMatcher(googleLoginEndpoint.matchFulfilled, (state, action) => {
      if (action.payload.activationStatus === ACTIVATION_STATUS.CONFIRMED) {
        state.isLoggedIn = true;
        setTokenCookies(action.payload.accessToken, action.payload.refreshToken);
      }
    });
    builder.addMatcher(googleRegisterEndpoint.matchFulfilled, (state, action) => {
      if (action.payload.activationStatus === ACTIVATION_STATUS.CONFIRMED) {
        state.isLoggedIn = true;
        setTokenCookies(action.payload.accessToken, action.payload.refreshToken);
      }
    });
  },
});

export const { setAuthState, setService, logout, setProfile, receiveMessage, readProfileMessage } =
  authSlice.actions;
export default authSlice.reducer;
